export default {"src":"/_next/static/media/waterpolo.ca3dc0bf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};